var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useToast } from '@/hoc';
import { closestCenter, DndContext } from '@dnd-kit/core';
import { arrayMove, SortableContext, useSortable, verticalListSortingStrategy, } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { useEffect, useRef, useState } from 'react';
import DeleteModal from '../delete-confirmation-modal/index';
import { ArrowUpIcon } from '../icons/arrow-up';
import { CrossIcon } from '../icons/cross-icon';
import { DragDropIcon } from '../icons/drag-drop-icon';
import { PlusIcon } from '../icons/plus-icon';
import { SubStatusItem } from '../sub-status-item';
import { Button, Text } from '../ui';
var StatusItem = function (_a) {
    var _b, _c, _d;
    var status = _a.status, isEditing = _a.isEditing, setStatuses = _a.setStatuses, isFirst = _a.isFirst, index = _a.index, deleteItem = _a.deleteItem, maxOrder = _a.maxOrder;
    // States
    var _e = useState(false), isExpanded = _e[0], setIsExpanded = _e[1];
    var contentRef = useRef(null);
    var _f = useState(false), showDeleteModal = _f[0], setShowDeleteModal = _f[1];
    var _g = useState(''), deleteItems = _g[0], setDeleteItems = _g[1];
    var _h = useSortable({
        id: status.id,
    }), attributes = _h.attributes, listeners = _h.listeners, setNodeRef = _h.setNodeRef, transform = _h.transform, transition = _h.transition;
    // Toast
    var showToast = useToast().showToast;
    // Internal computation
    useEffect(function () {
        if (isExpanded && contentRef.current) {
            contentRef.current.style.maxHeight = "".concat(contentRef.current.scrollHeight, "px");
        }
    }, [status.subStages, isExpanded]); // Recalculate height when subStages change
    // Handlers
    var handleStatusChange = function (id, newName) {
        // if (!newName.trim()) return; // Prevent empty names
        setStatuses(function (prev) {
            return prev.map(function (item) { return (item.id === id ? __assign(__assign({}, item), { name: newName }) : item); });
        });
    };
    var handleDelete = function () { return __awaiter(void 0, void 0, void 0, function () {
        var res, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, deleteItem(deleteItems)];
                case 1:
                    res = _a.sent();
                    if ((res === null || res === void 0 ? void 0 : res.status) === 'error') {
                        setShowDeleteModal(false);
                        showToast({ message: 'Failed to delete status', status: 'error' });
                        return [2 /*return*/];
                    }
                    setStatuses(function (prev) {
                        return prev
                            .filter(function (s) { return s.id !== deleteItems; })
                            .map(function (status) { return (__assign(__assign({}, status), { subStages: status.subStages.filter(function (sub) { return sub.sub_id !== deleteItems; }) })); });
                    });
                    showToast({ message: 'Status has been deleted', status: 'success' });
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    showToast({ message: 'Failed to delete status', status: 'error' });
                    return [3 /*break*/, 3];
                case 3:
                    setShowDeleteModal(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var handleAddSubStage = function (parentId) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            try {
                setStatuses(function (prev) {
                    return prev.map(function (item) {
                        return item.id === parentId
                            ? __assign(__assign({}, item), { subStages: __spreadArray(__spreadArray([], item.subStages, true), [
                                    {
                                        sub_id: Date.now().toString(),
                                        name: '',
                                        parentId: parentId,
                                        order: item.subStages.length + 1,
                                    },
                                ], false) }) : item;
                    });
                });
            }
            catch (error) {
                showToast({ message: 'Failed to update statuses', status: 'error' });
            }
            return [2 /*return*/];
        });
    }); };
    var handleSubStageChange = function (parentId, subId, newName) {
        setStatuses(function (prev) {
            return prev.map(function (status) {
                return status.id === parentId
                    ? __assign(__assign({}, status), { subStages: status.subStages.map(function (sub) {
                            return sub.sub_id === subId ? __assign(__assign({}, sub), { name: newName }) : sub;
                        }) }) : status;
            });
        });
    };
    var handleSubStageDragEnd = function (event) {
        var active = event.active, over = event.over;
        if (!over || active.id === over.id)
            return;
        setStatuses(function (prevStatuses) {
            return prevStatuses.map(function (statusItem) {
                if (statusItem.id === status.id) {
                    var oldIndex = statusItem.subStages.findIndex(function (sub) { return sub.sub_id === active.id; });
                    var newIndex = statusItem.subStages.findIndex(function (sub) { return sub.sub_id === over.id; });
                    // Move the subStage in the array
                    var newSubStages = arrayMove(statusItem.subStages, oldIndex, newIndex);
                    // Update order values sequentially
                    var updatedSubStages = newSubStages.map(function (subStage, index) { return (__assign(__assign({}, subStage), { order: index + 1 })); });
                    return __assign(__assign({}, statusItem), { subStages: updatedSubStages });
                }
                return statusItem;
            });
        });
    };
    return (_jsxs("div", { className: 'flex flex-col gap-2 px-[20px]', children: [_jsx("div", { ref: setNodeRef, style: { transform: CSS.Transform.toString(transform), transition: transition }, className: 'rounded-[10px] py-[6px] px-[10px] border border-[#EEEEEE] transition-all ', children: _jsxs("div", { className: 'flex items-center justify-between', children: [_jsxs("div", { className: 'flex items-center space-x-3 grow ', children: [isEditing && !isFirst && (_jsx("div", __assign({}, listeners, attributes, { className: 'cursor-grab p-1', children: _jsx(DragDropIcon, {}) }))), isEditing && !isFirst ? (_jsx("input", { type: 'text', required: true, value: status.name, onChange: function (e) { return handleStatusChange(status.id, e.target.value); }, className: "p-1 rounded w-full ".concat(!status.name.trim() && 'border-red-500') })) : (_jsxs(Text, { variant: 'description', children: [index + 1, ". ", status.name || ''] }))] }), _jsxs("div", { className: 'flex justify-center items-center gap-[6px]', children: [((_b = status.subStages) !== null && _b !== void 0 ? _b : []).length > 0 && (_jsx("button", { onClick: function () { return setIsExpanded(!isExpanded); }, className: 'rounded-md transition-transform duration-300', children: _jsx("div", { className: "transform ".concat(isExpanded ? 'rotate-0' : 'rotate-180'), children: _jsx(ArrowUpIcon, {}) }) })), isEditing && !isFirst && (_jsxs(_Fragment, { children: [_jsxs(Button, { onClick: function () { return handleAddSubStage(status.id); }, variant: 'outline', className: 'flex gap-2', size: 'sm', children: [_jsx(PlusIcon, { fillColor: 'currentColor' }), "Sub Stage"] }), _jsx(Button, { size: 'sm', variant: 'outline', onClick: function () {
                                                setShowDeleteModal(true);
                                                setDeleteItems(status.id);
                                            }, children: _jsx(CrossIcon, {}) })] }))] })] }) }), showDeleteModal && (_jsx(DeleteModal, { onConfirm: handleDelete, onClose: function () { return setShowDeleteModal(false); }, title: 'Are you sure you want to delete this Status?', subTitle: 'The candidates under deleted status are reassigned to fallback status.', positiveCtaText: 'Delete', negativeCtaText: 'Cancel' })), _jsx("div", { ref: contentRef, className: "overflow-hidden transition-all duration-500 ease-in-out", style: {
                    maxHeight: isExpanded ? "".concat((_c = contentRef.current) === null || _c === void 0 ? void 0 : _c.scrollHeight, "px") : '0px',
                    opacity: isExpanded ? 1 : 0,
                }, children: ((_d = status.subStages) !== null && _d !== void 0 ? _d : []).length > 0 && (_jsx(DndContext, { collisionDetection: closestCenter, onDragEnd: handleSubStageDragEnd, children: _jsx(SortableContext, { items: status.subStages, strategy: verticalListSortingStrategy, children: _jsx("div", { className: 'mb-2 space-y-2', children: status.subStages.map(function (subStage) { return (_jsx(SubStatusItem, { subStage: subStage, isEditing: isEditing, handleSubStageChange: handleSubStageChange, statusId: status.id, setShowDeleteModal: setShowDeleteModal, setDeleteItems: setDeleteItems }, subStage.sub_id)); }) }) }) })) })] }));
};
export default StatusItem;
